export const operatorShiftMode = {
  choose: 'Выбрать смену',
  manual: 'Создать смену',
};
export const operatorShiftModeList = [operatorShiftMode.choose, operatorShiftMode.manual];
